import React from 'react';
import '../style/Toast.css';
import { useSocket } from '../socket/SocketContext';

export default function ToastContainer() {
  const { toasts, dismissToast } = useSocket();

  if (!toasts || toasts.length === 0) return null;

  return (
    <div className="ToastStack">
      {toasts.map((toast) => (
        <div key={toast.id} className="Toast" onClick={() => dismissToast(toast.id)}>
          {toast.text}
        </div>
      ))}
    </div>
  );
}
